import React, { useState } from 'react';
import { Card, Col, Row } from 'antd';
import intl from 'react-intl-universal';
import { MONTHS } from 'utils/constants';
import { checkIsDate, getTodayMoment } from 'utils/date';
import { getConstantLabel, numberWithCommas } from 'utils/general';
import ExpandedDetails from 'views/Payout/components/Body/components/PayoutDetails/components/PayoutDetailCard/components/ExpandedDetails/ExpandedDetails';
import styles from 'views/Payout/components/Body/components/PayoutDetails/components/PayoutDetailCard/PayoutDetailCard.module.css';
import { calculateOtherCharges, mapReportToPayoutDetail } from '../pages/payoutV2/mapReportToCard';

const CardTitle = ({ propertyName, unitName, totalRevenue, currency, onClickTitle }) => (
  <div className={styles.title} onClick={onClickTitle}>
    <Row type="flex" justify="space-between">
      <Col span={12} className={styles.titleProperty}>
        {propertyName}
      </Col>
      <Col span={12} className={styles.titleTotal}>
        {intl.get('payout.headerLabels.cuurentCollected').d('Current Collected to Date')}
      </Col>
    </Row>
    <Row type="flex" justify="space-between">
      <Col span={12} className={styles.titleUnit}>
        {unitName}
      </Col>
      <Col span={12} className={styles.titleTotalAmount}>
        {currency} <span className={styles.titleTotalAmountNumber}>{totalRevenue}</span>
      </Col>
    </Row>
  </div>
);

const CardActionBar = ({ isCardExpand, onClickCardAction }) => (
  <span className={styles.actionLink} onClick={onClickCardAction}>
    {isCardExpand
      ? intl.get('payout.headerLabels.lessDetail').d('Less details')
      : intl.get('payout.headerLabels.moreDetail').d('More details')}
  </span>
);

const OwnerPayoutCardView = ({ card, shouldShowEarning, extraActions, invoice }) => {
  const [isCardExpand, setIsCardExpand] = useState(false);
  const payoutDetail = mapReportToPayoutDetail(card);
  const hasProtection = !!(payoutDetail.protection && payoutDetail.protection.certNo);
  const isProtectionActive =
    hasProtection && checkIsDate('after', payoutDetail.protection.insuranceEndDate, getTodayMoment());
  const amountLabel = numberWithCommas(
    payoutDetail.youEarn != null ? payoutDetail.youEarn : payoutDetail.perUnitRevenue
  );
  const currency = payoutDetail.unit.currency;
  const year = Number(card && card.year) || 0;
  const monthIndex = Math.max(0, Number(card && card.month) - 1);
  const monthLabel = getConstantLabel(MONTHS, monthIndex);
  const showEarning = shouldShowEarning !== false;

  const expandCollapseCard = () => setIsCardExpand(prev => !prev);

  const actions = [<CardActionBar key="more" isCardExpand={isCardExpand} onClickCardAction={expandCollapseCard} />].concat(
    extraActions || []
  );

  return (
    <div className={styles.cardWrapper}>
      <Card
        className={`${styles.card} ${hasProtection ? styles.cardHostProtected : styles.cardHostUnprotected}`}
        title={
          <CardTitle
            propertyName={payoutDetail.property.name}
            unitName={payoutDetail.unit.name}
            currency={currency}
            totalRevenue={amountLabel}
            onClickTitle={expandCollapseCard}
          />
        }
        actions={actions}
      >
        {isCardExpand && (
          <ExpandedDetails
            year={year}
            month={monthIndex}
            payoutDetail={payoutDetail}
            hasProtection={hasProtection}
            isProtectionActive={isProtectionActive}
            shouldSplitBySqft={false}
            calculateOtherCharges={calculateOtherCharges}
            showFreeStay
          />
        )}
        <div>
          <Row
            type="flex"
            justify="space-between"
            className={`${styles.generalDetailsText} ${
              showEarning ? styles.generalDetailsTextEarning : styles.generalDetailsTextNoEarning
            }`}
            onClick={expandCollapseCard}
          >
            {showEarning ? (
              <>
                {intl.get('payout.headerLabels.youEarn').d('You earn')}
                <Col>
                  <span className={styles.titleTotalAmount}>{currency} </span>
                  {amountLabel}
                </Col>
              </>
            ) : (
              <>
                {intl.get('payout.headerLabels.generate').d('Generate AFTER END of')}{' '}
                {intl.get(`payout.months.${monthLabel}`).d(monthLabel)} {year}
              </>
            )}
          </Row>
          <div className={styles.generalDetailsButton}>{invoice}</div>
        </div>
      </Card>
    </div>
  );
};

export default OwnerPayoutCardView;
